import React from 'react';
import { BookOpen, Bus } from 'lucide-react';
import { Switch } from './ui/switch';
import { isSchoolFeatureEnabled } from '../utils/schoolFeatures';

/**
 * Per-student library/transport facility toggles (shown only when school module is on).
 */
export default function StudentFacilityToggles({
  uses_library = false,
  uses_transport = false,
  onChange,
  disabled = false,
  schoolFeatures,
}) {
  const ctx = { school_features: schoolFeatures };
  const showLibrary = isSchoolFeatureEnabled(ctx, 'library');
  const showTransport = isSchoolFeatureEnabled(ctx, 'transport');

  if (!showLibrary && !showTransport) {
    return null;
  }

  return (
    <div className="space-y-4">
      {showLibrary && (
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <BookOpen className="w-4 h-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">Uses library facility</p>
              <p className="text-xs text-muted-foreground">Adds library fees when enabled</p>
            </div>
          </div>
          <Switch
            checked={!!uses_library}
            disabled={disabled}
            onCheckedChange={(v) => onChange('uses_library', v)}
          />
        </div>
      )}
      {showTransport && (
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Bus className="w-4 h-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium text-foreground">Uses transport facility</p>
              <p className="text-xs text-muted-foreground">Adds transport fees when enabled</p>
            </div>
          </div>
          <Switch
            checked={!!uses_transport}
            disabled={disabled}
            onCheckedChange={(v) => onChange('uses_transport', v)}
          />
        </div>
      )}
    </div>
  );
}
